'use strict';

var core = require('core/components/search');
var endpoint = $('.suggestions-wrapper').data('url');
var sitePreferencesUtils = require('core/preferences/sitePreferencesUtils');
var preferences = sitePreferencesUtils.getSitePreferences();
var minChars = preferences.headerSearchMinTermLength;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).closest('form').find('.suggestions-wrapper');
}

function resetSearch () {
    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
        $(this).siblings('.fa-search').removeClass('d-none');
        $(this).siblings('input.search-field').val('').trigger('focus');
    });
}

function openDesktopSearch(event) {
    var $desktopSearch = $('#desktop-search');
    $desktopSearch.find('input.search-field').val('');
    $desktopSearch.find('.suggestions-wrapper').empty();
    $desktopSearch.find('.fa-search').removeClass('d-none');
    $desktopSearch.fadeIn(300, function() {
        //$(this).css('display', 'flex');
        $desktopSearch.attr('aria-expanded', 'true');
        $('header .site-search-trigger').attr('tabindex', '-1');
        $desktopSearch.find('input.search-field').trigger('focus');
        // edge case: user was in mobile view and closed search, then switched to desktop view.
        $desktopSearch.find('form').spinner().stop();
    });
}

function resetDesktopSearch (event) {
    //console.log('resetDesktopSearch event:', event);
    var $desktopSearch = $('#desktop-search');
    $desktopSearch.fadeOut(300, function($this) {
        // Immediately reset the search form so it's ready next time it's opened
        $desktopSearch.attr('aria-expanded', 'false').find('.suggestions-wrapper').empty();
        $desktopSearch.find('.reset-desktop-button').removeClass('d-sm-block').attr('tabindex', '-1');
        $desktopSearch.find('.fa-search').removeClass('d-none');
        $('header .site-search-trigger').attr('tabindex', '0');
    });
}

// Desktop search escape key returns focus to search trigger
function closeWithEscapeKey() {
    var $desktopSearch = $('#desktop-search');
    $desktopSearch.on('keydown', 'a, input.search-field, .suggestions', function(event) {
        if (event.key === 'Escape') {
            resetDesktopSearch();
            $('header .site-search-trigger').trigger('focus');
        }
    });
}

// This handles when the user clicks outside the search
// It closes the search dropdown if it's open
// Tabbing past search results will also close it, but that is handled in ada.js megamenu section
function closeOnBlur() {
    var refinementSearchTrigger = $('.filter-search-trigger');
    $(document).on('click', function(event) {
        var isRefinementSearchTrigger = refinementSearchTrigger.hasClass(event.target.className) || refinementSearchTrigger.find('.' + event.target.className).length;
        var closeLogic = !event.target.className.includes('site-search')
            && !event.target.className.includes('js-search-results')
            && !event.target.className.includes('search-field')
            && refinementSearchTrigger
            && !isRefinementSearchTrigger;
        //console.log('closeLogic:', closeLogic);
        // Check if the clicked element is outside of 'desktopSearch' AND 'searchTrigger' OR 'refinementSearchTrigger'
        if (closeLogic) {
            // The click occurred outside of 'desktopSearch' AND 'searchTrigger' OR 'refinementSearchTrigger'
            // close the search dropdown but don't focus back to search trigger
            //console.log('isRefinementSearchTrigger:', isRefinementSearchTrigger);
            resetDesktopSearch(event);
        }
    });

    $('.minicart-link').on('focus', function(event) {
        resetDesktopSearch(event);
    });
}

function desktopSearchTrigger() {
    $('body').on('open:search', function(event) {
        openDesktopSearch(event);
    }).on('reset:search', function(event) {
        resetDesktopSearch(event);
    });

    $('header .site-search-trigger').on('click', function(event) {
        event.preventDefault();
        $('body').trigger('open:search');
    });
    $('body').on('click', '.filter-search-btn', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('body').trigger('open:search');
    });

    $('.site-search .reset-desktop-button').on('click', function (event) {
        resetDesktopSearch(event);
    });

    // This override for app_storefront_base prevents the search from closing when clicking inside the search suggestions area
    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').show();
        }
    });
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        var isMobile = module.exports.isMobileSearch(this);
        if (isMobile) {
            $('.js-search-results').spinner().start();
        } else {
            $('#desktop-search .suggestions-wrapper').spinner().start();
        }
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: module.exports.processResponse,
            error: function () {
                if (isMobile) {
                    $('.js-search-results').spinner().stop();
                } else {
                    $('#desktop-search .suggestions-wrapper').spinner().stop();
                }
            }
        });
    } else {
        module.exports.toggleSuggestionsIcon('search');
        if (isMobile) {
            $(scope).siblings('.reset-button').removeClass('d-sm-block');
        } else {
            $(this).siblings('.fa-search').removeClass('d-none');
        }
        module.exports.clearModals();
        module.exports.getSuggestionsWrapper(scope).empty();
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    var isMobile = module.exports.isMobileSearch(this);
    var $navigationMenu = $('.main-menu.menu-toggleable-left');

    if (isMobile) {
        $('.js-search-results').spinner().stop();
    } else {
        $('#desktop-search .suggestions-wrapper').spinner().stop();
    }

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-sm-block');
        module.exports.positionSuggestions(this);

        if (isMobile) {
            module.exports.toggleSuggestionsIcon('close');
            module.exports.applyModals(this);
        } else {
            $(this).siblings('.fa-search').addClass('d-none');
            // hidden elements should not be tabbable
            $(this).siblings('.reset-button').attr('tabindex', '0');
        }

        if ($navigationMenu.hasClass('in')) {
            $navigationMenu.removeClass('in');
            $navigationMenu.attr('aria-hidden', 'true');
            $('body').removeClass('mobile-menu-in');
            $('html').removeClass('lock-scroll');
            $('.modal-background').hide();
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}



core.getSuggestionsWrapper = getSuggestionsWrapper;
core.getSuggestions = getSuggestions;
core.processResponse = processResponse;
core.resetSearch = resetSearch;
core.closeWithEscapeKey = closeWithEscapeKey;
core.closeOnBlur = closeOnBlur;
core.desktopSearchTrigger = desktopSearchTrigger;

core.init = function() {
    module.exports.simpleSearch();
    module.exports.searchKeyListener();
    module.exports.hideSuggestions();
    module.exports.closeOnMobile();
    module.exports.resetSearch();
    module.exports.closeWithEscapeKey();
    module.exports.closeOnBlur();
    module.exports.desktopSearchTrigger();
}

module.exports = core;
